// extracted by mini-css-extract-plugin
module.exports = {"shadow":"styles_shadow__OYm0y","shadowGrid":"styles_shadowGrid___YTk_","unsupportedRegion":"styles_unsupportedRegion__al_0l"};